let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    // A subscriber that throws (synchronously or via a rejected promise) used
    // to abort Array.prototype.map partway through, silently skipping every
    // subscriber registered after it for that event - including the cart
    // safety net in standard-actions-override.js. Isolate each subscriber so
    // one broken listener can never block the others.
    const promises = subscribers[eventName].map((callback) => {
      try {
        return Promise.resolve(callback(data)).catch((error) => {
          console.error('[pubsub] subscriber for "' + eventName + '" rejected:', error);
        });
      } catch (error) {
        console.error('[pubsub] subscriber for "' + eventName + '" threw:', error);
        return undefined;
      }
    });
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}
